import { render } from "./FormWrapper.vue?vue&type=template&id=44533b98&scoped=true&ts=true"
import script from "./FormWrapper.vue?vue&type=script&lang=ts"
export * from "./FormWrapper.vue?vue&type=script&lang=ts"

import "./FormWrapper.vue?vue&type=style&index=0&id=44533b98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44533b98"]])

export default __exports__